import { BaseService } from './BaseService';

const PORTAL_DEFAULTS = {
    ERROR_TEXT: 'There was an error with your request.',
    BASE_API_URL: window.location.origin
}

export class BasePortalService extends BaseService {
    constructor() {
        super();
        this.options = Object.assign({}, this.options, PORTAL_DEFAULTS);

    }
}